
const apiConfig = {
                       baseURL: "https://api.jk77.live",
                    //  baseURL: "http://localhost:5000",
                  };

export default apiConfig;